import { __assign } from "tslib";
import * as actionTypes from '../constants/actionTypes';
export default function userReducer(state, action) {
    var _a;
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case actionTypes.SET_USER_PROP:
            return __assign(__assign({}, state), (_a = {}, _a[action.key] = action.value, _a));
        default:
            return state;
    }
}
